module.exports = __webpack_public_path__ + "img/page-info.d3bda280.png";